import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { ArchitectureObservabilityIcon, MessageBusGraphIcon } from '@/components/shared';

export function DeveloperToolCard() {
  return (
    <div className="grid max-w-xl gap-3">
      <Link
        to="/developer/messagebus"
        className="focus-ring group flex max-w-xl items-start gap-4 rounded-lg border border-neutral-200 bg-white p-5 transition hover:border-backoffice-300 hover:bg-backoffice-50"
      >
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-backoffice-100 text-backoffice-700">
          <MessageBusGraphIcon className="h-5 w-5" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="flex items-center justify-between gap-3">
            <h2 className="text-lg font-semibold text-neutral-900">Message bus</h2>
            <ArrowRight
              className="h-5 w-5 shrink-0 text-neutral-500 transition group-hover:translate-x-0.5 group-hover:text-backoffice-700"
              aria-hidden="true"
            />
          </div>
          <p className="mt-1 text-body text-neutral-600">
            Inspect message bus status, topics, subscribers, and messages.
          </p>
        </div>
      </Link>
      <Link
        to="/developer/observability"
        className="focus-ring group flex items-start gap-4 rounded-lg border border-neutral-200 bg-white p-5 transition hover:border-backoffice-300 hover:bg-backoffice-50"
      >
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-backoffice-100 text-backoffice-700">
          <ArchitectureObservabilityIcon className="h-5 w-5" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="flex items-center justify-between gap-3">
            <h2 className="text-lg font-semibold text-neutral-900">Architecture observability</h2>
            <ArrowRight className="h-5 w-5 shrink-0 text-neutral-500" aria-hidden="true" />
          </div>
          <p className="mt-1 text-body text-neutral-600">
            Inspect live services, health, and request traffic.
          </p>
        </div>
      </Link>
    </div>
  );
}
